import { RESTAURANTS } from "../Constants/Endpoints";
import { ApiRequestInterceptor } from "./apiRequest";

export const fetchChangePaymentStatus = async (restauranteId, body) => {
  // encodea SOLO el segmento dinámico del path
  const path = RESTAURANTS.paymentStatus.replace(
    "{restauranteId}",
    encodeURIComponent(restauranteId)
  );

  const resp = await ApiRequestInterceptor(path, "PATCH", body);

  // Normaliza la respuesta
  const payload =
    (typeof resp?.body === "string" ? JSON.parse(resp.body) : resp?.body) ??
    resp?.data ??
    resp;

  const statusCode = resp?.statusCode ?? payload?.statusCode ?? resp?.code ?? 500;
  const message = payload?.message || resp?.message || "Error al cambiar estado de pago";
  const order = payload?.order ?? null;

  return { statusCode, message, order, raw: resp };
};